// Keeps the toast stack just below the navbar. The navbar is fixed, shrinks once
// the page is scrolled, and is not there at all for somebody signed out, so its
// height is measured rather than written into the stylesheet.
up.compiler('#toasts', (stack) => {
  // The navbar itself: its wrapper `.layout--navigation` has no height of its own,
  // because the `fixed-top` navbar inside it is taken out of the flow.
  const navbar = document.querySelector('.navbar.fixed-top')
  if (!navbar) return

  const place = () => {
    stack.style.setProperty('--toast-stack-top', `${navbar.getBoundingClientRect().bottom}px`)
  }

  const observer = new ResizeObserver(place)
  observer.observe(navbar)
  place()

  return () => observer.disconnect()
})
